import AdminPortal from "../Components/admin";

const AdminPage = (props) => {
  return <AdminPortal />;
};

export default AdminPage;
